export default {
  title: 'Parece que estás sin conexión',
  description: 'Haz clic en «Recargar página» y/o comprueba tu conexión a internet 😊',
  custom_button: {
    reload: 'Recargar página',
  },
};
